// Validation and Sanitization utilities

export function sanitizeString(str) {
  if (typeof str !== 'string') return str;
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/`/g, '&#96;')
    .trim();
}

export function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email);
}

export function isValidPhone(phone) {
  if (!phone) return true;
  const phoneRegex = /^[\+]?[(]?[0-9]{1,3}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
}

export function isValidPassword(password) {
  return password && password.length >= 6;
}

export function isValidName(name) {
  if (!name || name.trim().length < 2) return false;
  const nameRegex = /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s\-'\.]+$/;
  return nameRegex.test(name.trim());
}

export const errorMessages = {
  required: 'Este campo es requerido',
  email: 'Ingresa un correo electrónico válido',
  phone: 'Ingresa un número de teléfono válido',
  password: 'La contraseña debe tener al menos 6 caracteres',
  passwordMatch: 'Las contraseñas no coinciden',
  name: 'Ingresa un nombre válido (mínimo 2 caracteres)',
  date: 'Selecciona una fecha válida',
  number: 'Ingresa un número válido',
  minLength: (min) => 'Mínimo ' + min + ' caracteres',
  security: 'El texto contiene caracteres no permitidos',
};

export function validateField(value, rules = {}) {
  const trimmedValue = typeof value === 'string' ? value.trim() : value;
  if (rules.required && (!trimmedValue || trimmedValue === '')) return errorMessages.required;
  if (!trimmedValue && !rules.required) return null;
  if (rules.email && !isValidEmail(trimmedValue)) return errorMessages.email;
  if (rules.phone && trimmedValue && !isValidPhone(trimmedValue)) return errorMessages.phone;
  if (rules.password && !isValidPassword(trimmedValue)) return errorMessages.password;
  if (rules.name && !isValidName(trimmedValue)) return errorMessages.name;
  if (rules.minLength && trimmedValue.length < rules.minLength) return errorMessages.minLength(rules.minLength);
  if (rules.secure && !isSecureInput(trimmedValue)) return errorMessages.security;
  if (rules.custom) return rules.custom(trimmedValue);
  return null;
}

export function containsXSS(str) {
  if (typeof str !== 'string') return false;
  const xssPatterns = [/<script/gi, /javascript:/gi, /on\w+\s*=/gi, /<iframe/gi, /<object/gi, /<embed/gi];
  return xssPatterns.some(pattern => pattern.test(str));
}

export function isSecureInput(str) {
  return typeof str !== 'string' || !containsXSS(str);
}
